import {Grid, Link, Modal} from '@mui/material'
import React from 'react'
import WbModal from './WbModal'
import artifactApi from '../../services/api/artifacts/artifactService'
import WbButton from './WbButton'

export default function WbFileUpload({setImageName, button = false}) {
  const [show, setShow] = React.useState(false)
  const [uploading, setUploading] = React.useState(false)
  return (
    <>
      {button ? (
        <WbButton
          CustomButtonText={'Upload Image'}
          onClick={e => setShow(true)}          
        />
      ) : (
        <Link href="#" onClick={e => setShow(true)} color="#E84F6B" underline='hover'>
          Change Image
        </Link>
      )}
      {show && (
        <WbModal
          title="Upload Image"
          content={
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12} my={3}>
                <input
                  disabled={uploading}
                  type="file"
                  accept=".jpg, .png, .gif"
                  onChange={e => {
                    setUploading(true)
                    var formData = new FormData()
                    formData.append('file', e.target.files[0])
                    artifactApi
                      .post(formData)
                      .then(res => {
                        setImageName(res.filePath)
                        setShow(false)
                      })
                      .catch(err => console.error(err))
                      .finally(() => setUploading(false))
                  }}
                ></input>
              </Grid>
            </Grid>
          }
          onClose={() => setShow(false)}
        />
      )}
    </>
  )
}
